<template src="@/templates/passenger/passport.html"></template>

<script>
  import userApi from '@/api/userApi';

  export default {
    name: 'passport',
    props: {
      passenger: {
        required: true,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        city_of_birth: '',
        country_of_birth: '',
        passport_number: '',
        passport_city: '',
        passport_country: '',
        date_issue_passport: '',
        passport_expire_date: '',
        editing: false,
        errors: {},
      };
    },
    watch: {
      passenger() {
        this.setDataFromPassenger();
      },
    },
    mounted() {
      this.setDataFromPassenger();
    },
    methods: {
      setDataFromPassenger() {
        this.city_of_birth = this.passenger.city_of_birth;
        this.country_of_birth = this.passenger.country_of_birth;
        this.passport_number = this.passenger.passport_number;
        this.passport_city = this.passenger.passport_city;
        this.passport_country = this.passenger.passport_country;
        this.date_issue_passport = this.passenger.passport_issue_date;
        this.passport_expire_date = this.passenger.passport_expire_date;
      },
      getDataForUpdate() {
        return {
          city_of_birth: this.city_of_birth,
          country_of_birth: this.country_of_birth,
          passport_number: this.passport_number,
          passport_city: this.passport_city,
          passport_country: this.passport_country,
          date_issue_passport: this.date_issue_passport,
          passport_expire_date: this.passport_expire_date,
        };
      },
      edit() {
        this.editing = true;
      },
      save() {
        const passengerId = this.passenger.id;
        const data = this.getDataForUpdate();
        userApi.updatePassengerPassport(passengerId, data, () => {
          this.$emit('reload');
          this.editing = false;
          this.errors = {};
        }, (error) => {
          this.errors = error.response.data;
        });
      },
      cancel() {
        this.editing = false;
        this.setDataFromPassenger();
      },
      hasError(index) {
        if (this.errors[index]) {
          return this.errors[index][0];
        }
        return null;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// passport.vue?7e2a1676